module.exports = __webpack_public_path__ + "static/img/where-we-develop.22f486b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/where-we-develop.png
// module id = ZLXm
// module chunks = 1